import {Middleware} from 'redux'
import {ninchatEventActions} from 'api/slice'

export const filterMiddleware: Middleware = ({getState}) => (next) => (action) => {
    switch (action.type) {
        case ninchatEventActions.user_updated.type: {
            const sessionUserId = getState().ninchat.user_id
            const userId = action.payload.user_id
            const users = getState().ninchat._users

            if (!(userId in users) && userId !== sessionUserId) {
                return null
            }

            return next(action)
        }
        default:
            return next(action)
    }
}
